(() => {
  let dialog, contentHost, activeCard, returnFocus, requestController, activeMode;
  let requestNumber = 0;
  async function addToCart(form, status, card) {
    const button = form.querySelector('[type="submit"]');
    if (!button || button.disabled) return;
    button.disabled = true;
    status.textContent = '';
    try {
      await window.VarelleaCart.add(form);
      status.textContent = card.dataset.addedLabel;
      if (dialog?.open && dialog.contains(form)) dialog.close();
      await window.VarelleaCart.refresh(card.dataset.cartCountLabel, { source: 'add', openDrawer: true });
    } catch (error) {
      status.textContent = error.message || card.dataset.errorLabel;
    } finally { button.disabled = false; }
  }

  async function loadView(productUrl, focusPosition) {
    requestController?.abort();
    const sequence = ++requestNumber;
    requestController = new AbortController();
    const close = dialog.querySelector('.varellea-quick-view__close');
    close.setAttribute('aria-label', activeCard?.dataset.closeLabel || 'Close');
    dialog.setAttribute('aria-label', activeCard?.querySelector('.varellea-product-card__title')?.textContent?.trim() || 'Product quick view');
    if (!dialog.open) dialog.showModal();
    const oldQuantity = contentHost.querySelector('[name="quantity"]')?.value;
    if (!focusPosition) { contentHost.textContent = activeCard?.dataset.loadingLabel || 'Loading'; close.focus(); }
    else contentHost.querySelector('[data-quick-view-content]')?.setAttribute('aria-busy', 'true');
    const url = new URL(productUrl, location.origin);
    url.searchParams.set('view', 'quick-view');
    try {
      const response = await fetch(url, { signal: requestController.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error(activeCard?.dataset.errorLabel || 'Unable to load product');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = parsed.querySelector('[data-quick-view-content]');
      if (!content) throw new Error(activeCard?.dataset.errorLabel || 'Unable to load product');
      if (sequence !== requestNumber || !dialog.open) return;
      const quantity = content.querySelector('[name="quantity"]');
      if (quantity && oldQuantity) quantity.value = oldQuantity;
      contentHost.replaceChildren(content);
      if (focusPosition) content.querySelector(`[data-option-position="${focusPosition}"] [data-quick-view-option]:checked`)?.focus({ preventScroll: true });
      else if (activeMode === 'buy') (content.querySelector('[data-quick-view-option]:checked') || content.querySelector('[data-quick-view-buy]'))?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name === 'AbortError') return;
      contentHost.textContent = activeCard?.dataset.errorLabel || 'Unable to load product';
      const fallback = document.createElement('a'); fallback.href = productUrl; fallback.textContent = activeCard?.querySelector('.varellea-product-card__title')?.textContent || 'View product'; contentHost.append(fallback);
    }
  }

  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'varellea-quick-view';
    dialog.setAttribute('aria-modal', 'true');
    const close = document.createElement('button');
    close.type = 'button'; close.className = 'varellea-quick-view__close'; close.textContent = '×';
    close.addEventListener('click', () => dialog.close());
    contentHost = document.createElement('div');
    dialog.append(close, contentHost);
    document.body.append(dialog);
    dialog.addEventListener('close', () => {
      requestController?.abort();
      (returnFocus?.isConnected ? returnFocus : activeCard?.querySelector('[data-open-quick-view]'))?.focus();
      activeCard = null;
    });
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('change', event => {
      const option = event.target.closest('[data-quick-view-option]');
      if (!option || !option.checked) return;
      const position = option.closest('[data-option-position]')?.dataset.optionPosition;
      if (option.dataset.productUrl) { loadView(option.dataset.productUrl, position); return; }
      const productUrl = contentHost.querySelector('[data-product-url]')?.dataset.productUrl;
      if (!productUrl) return;
      const next = new URL(productUrl, location.origin);
      const ids = [...contentHost.querySelectorAll('[data-quick-view-option-group]')].map(group => group.querySelector('[data-quick-view-option]:checked')?.value).filter(Boolean);
      next.searchParams.set('option_values', ids.join(','));
      loadView(next.toString(), position);
    });
    dialog.addEventListener('submit', event => {
      const form = event.target.closest('.varellea-quick-view__form');
      if (!form) return;
      event.preventDefault();
      if (activeCard) addToCart(form, form.querySelector('[data-quick-view-feedback]'), activeCard);
    });
  }

  window.Varellea.register('product-card', root => {
    const controller = new AbortController();
    const signal = controller.signal;
    return {
      connect() {
        root.addEventListener('click', event => {
          const swatch = event.target.closest('[data-card-swatch]');
          if (swatch && root.contains(swatch)) {
            if (swatch.dataset.combined === 'true' || !swatch.dataset.variantId) return;
            event.preventDefault();
            root.querySelectorAll('[data-card-swatch]').forEach(item => { item.dataset.selected = String(item === swatch); item.setAttribute('aria-label', item.dataset.baseLabel + (item === swatch ? `, ${root.dataset.selectedLabel}` : '')); });
            root.dataset.selectedUrl = swatch.href;
            root.querySelectorAll('[data-open-quick-view]').forEach(link => { link.href = swatch.href; });
            root.querySelectorAll('.varellea-product-card__image-link, .varellea-product-card__title a').forEach(link => { link.href = swatch.href; });
            const image = root.querySelector('.varellea-product-card__image--primary');
            if (image && swatch.dataset.imageUrl) { image.srcset = ''; image.src = swatch.dataset.imageUrl; root.querySelector('.varellea-product-card__image--secondary')?.setAttribute('hidden', ''); }
            const price = root.querySelector('[data-price-value]'); if (price) price.textContent = swatch.dataset.price;
            const compare = root.querySelector('[data-compare-price]'); if (compare) { compare.hidden = swatch.dataset.sale !== 'true'; compare.querySelector('[data-compare-value]').textContent = swatch.dataset.compare; }
            const available = swatch.dataset.available === 'true';
            const saleBadge = root.querySelector('[data-card-sale-badge]'); const soldBadge = root.querySelector('[data-card-sold-badge]');
            if (saleBadge) saleBadge.hidden = !available || swatch.dataset.sale !== 'true';
            if (soldBadge) soldBadge.hidden = available;
            const variantInput = root.querySelector('[data-card-variant-id]'); if (variantInput) variantInput.value = swatch.dataset.variantId;
            const buyButton = root.querySelector('[data-card-buy-button]'); if (buyButton) buyButton.disabled = !available;
            return;
          }
          const trigger = event.target.closest('[data-open-quick-view]');
          if (!trigger || !root.contains(trigger)) return;
          event.preventDefault();
          ensureDialog();
          activeCard = root; returnFocus = trigger; activeMode = trigger.dataset.viewMode;
          loadView(trigger.href);
        }, { signal });
        root.addEventListener('submit', event => {
          const form = event.target.closest('.varellea-product-card__buy-form');
          if (!form) return;
          event.preventDefault();
          addToCart(form, root.querySelector('[data-card-status]'), root);
        }, { signal });
      },
      disconnect() { controller.abort(); if (activeCard === root && dialog?.open) dialog.close(); }
    };
  });
})();
